import workflowFormRouter from '../router/workflowFormRouter'
export default
{
    path: "/task",
    component: () => import('../view/task/TaskListMain.vue'),
    children: [
        {
            path: 'taskList',
            name: 'taskList',
            component: () => import('../view/task/TaskList.vue'),
            children:[
                {
                    path: "workflow",
                    component: () => import('../view/workflow/WorkflowFormMain.vue'),
                    children: [
                        workflowFormRouter
                    ]
            
                }
            ]
        }
    ]

}



// WEBPACK FOOTER //
// ./src/router/taskRouter.js